import { render } from "./FiltersGetEnrollment.vue?vue&type=template&id=70963216&scoped=true"
import script from "./FiltersGetEnrollment.vue?vue&type=script&lang=js"
export * from "./FiltersGetEnrollment.vue?vue&type=script&lang=js"

import "./FiltersGetEnrollment.vue?vue&type=style&index=0&id=70963216&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70963216"]])

export default __exports__